"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _AST = _interopRequireDefault(require("./AST"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var POSITION_ID = 'position';
var TEXT_ARGUMENT_ID = 'text';
var SEARCH_ARGUMENT_ID = 'search';
var ASTCompiler = exports["default"] = /*#__PURE__*/function () {
  function ASTCompiler(astBuilder) {
    _classCallCheck(this, ASTCompiler);
    this.astBuilder = astBuilder;
  }
  return _createClass(ASTCompiler, [{
    key: "compile",
    value: function compile(text) {
      var ast = this.astBuilder.ast(text);
      this.state = {
        body: [],
        vars: [],
        nextId: 0
      };
      this.recurse(ast);
      var fnString = "\n        let ".concat(POSITION_ID, " = 0;\n        ").concat(this.state.vars.length ? "let ".concat(this.state.vars.join(','), ";") : '', "\n        ").concat(this.state.body.join(''), "\n    ");
      return new Function(TEXT_ARGUMENT_ID, SEARCH_ARGUMENT_ID, fnString);
    }
  }, {
    key: "recurse",
    value: function recurse(ast) {
      var intoId;
      switch (ast.type) {
        case _AST["default"].Program:
          this.state.body.push('return ', this.recurse(ast.body), ';');
          break;
        case _AST["default"].UnaryExpression:
          intoId = this.nextId();
          this.state.body.push(this.assign(intoId, "".concat(ast.operator, "(").concat(this.recurse(ast.argument), ")")));
          return intoId;
        case _AST["default"].Query:
          intoId = this.nextId();
          this.state.body.push(this.query(intoId, ast.value));
          return intoId;
        case _AST["default"].LogicalExpression:
          intoId = this.nextId();
          this.state.body.push(this.assign(intoId, this.recurse(ast.left)));
          this.state.body.push(this.if_(ast.operator === '&' ? intoId : this.not(intoId), this.assign(intoId, this.recurse(ast.right))));
          return intoId;
      }
    }
  }, {
    key: "nextId",
    value: function nextId() {
      var id = "v".concat(this.state.nextId++);
      this.state.vars.push(id);
      return id;
    }
  }, {
    key: "if_",
    value: function if_(test, consequent) {
      return "\n      if (".concat(test, ") {\n        ").concat(consequent, "\n      }\n    ");
    }
  }, {
    key: "not",
    value: function not(test) {
      return "!(".concat(test, ")");
    }
  }, {
    key: "assign",
    value: function assign(id, value) {
      return "\n      ".concat(id, " = ").concat(value, ";\n    ");
    }
  }, {
    key: "query",
    value: function query(id, _query) {
      return "\n      [".concat(id, ", ").concat(POSITION_ID, "] = ").concat(SEARCH_ARGUMENT_ID, "(").concat(TEXT_ARGUMENT_ID, ", \"").concat(_query, "\", ").concat(POSITION_ID, ")\n    ");
    }
  }]);
}();